import { Component } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from './../../../services/data/data.service';
import Swal from 'sweetalert2';
import { NgModel } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { getAsignacionesInst, getCuestionarioPorId, getEstatusHoja, getHojaRespuesta } from '../../../services/Administrador/cuestionarios/query';
import { environment } from './../../../../environments/environment';
import { HojaRespuestasService } from '../../../services/cuestionarios/cuestionario/hoja-respuestas.service';
import { firstValueFrom, retry } from 'rxjs';
import { ConstantesImagenes } from '../../../../app/models/Cuestionarios/codigoimagenes';
import { messages } from '../../funciones/mensajes';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import pdfMake from 'pdfmake/build/pdfmake';
pdfMake['vfs'] = pdfFonts;

@Component({
  selector: 'app-cuestionarios-asignados',
  templateUrl: './cuestionarios-asignados.component.html',
  styleUrl: './cuestionarios-asignados.component.css'
})
export class CuestionariosAsignadosComponent {
  public listaCuestionario = true; //true = listado false = responderCuestionario
  public cuesAsig = [];
  public cuestionarios = [];
  public respCuestionario = {};
  private pregRequeridas = [];
  public hojaRespuesta = [];
  public cuesSelec;
  private semaforos = [];
  public sinContestar = [];
  public bndTerminar = false;
  public incompleto = false;
  private idHojaRes = 0;
  public filtroBusqueda: string = ''; 
  public cuesAsigFiltrados = [];


  public selec = -1;
  
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private errorMessage = '<br/><br/><div> <span style="text-aling: center;font-size: 10pt;font-weight: 200;">Presione</span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 600;"> esc </span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 200;">para cerrar</span></div>';

  public reporteGeneradoExitosamente: boolean = true;
  public isDownloadingPdf = false;
  private reportName = 'Reporte.pdf';
  private pdfFile: any;
  private imgLogo;
  constructor(
    private apollo: Apollo,
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private answerSheet: HojaRespuestasService,
    private imageService: HojaRespuestasService
  ) {
    moment.updateLocale('en',{
      months: [
        "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto",
        "Septiembre","Octubre","Noviembre","Diciembre"
      ],
      monthsShort: [
        "ene","feb","mar","abr","may","jun","jul","ago",
        "sep","oct","nov","dic"
      ]
    });
    localStorage.setItem('sinGuardar','false');
    this.getLogo();
  }
  ngOnInit(){
    this.getAsignacionesUser();
  }

  public posScroll(id){
    setTimeout( () =>{
      const element = document.getElementById(id);
      element.scrollIntoView({behavior: 'smooth', block: 'start'})
    }, 300 );
  }

  public async mensajeSugerencia(txt){
    txt = this.translate.instant(txt);
    messages.infoMessageGraph(txt);
  }
  
  //Obtencion de los cuestionarios asignados a la institucion del usuario
  private async getAsignacionesUser(){
    try{
      const asig = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getAsignacionesInst,
          context: { headers: this.headers, },
          }).valueChanges.source
      );
      this.cuesAsig = [];
      for(const as of asig.data.availableSurveys){
        if(this.dataService.role === 'Rol_Administrador_cuestionarios' || as.institution_id === this.dataService.idInstitution){
          var est = '';
          // Lógica para verificar si la fecha de fin ha pasado
          const dueDate = moment(as.due_date);
          const now = moment();
          const isOverdue = now.isAfter(dueDate);
          try{
            const estatusHoja = await firstValueFrom(
              this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
                query: getEstatusHoja,
                context: { headers: this.headers, },
                variables: { allocationId: Number(as.id) },
                fetchPolicy: 'no-cache',
              }).valueChanges.source 
            );
            if(estatusHoja.data.findAnswerSheet.status == 'uncompleted'){
                if (isOverdue) {
                    // Cuestionario incompleto y tiempo expirado -> PENDIENTE
                    est = 'pending'; 
                } else if (as.status == 'open') {
                    // Cuestionario incompleto pero dentro del plazo -> ABIERTO
                    est = 'open';
                } else {
                    // Incompleto, pero la asignación está cerrada por el administrador -> CERRADO
                    est = 'close';
                }
            }else{
                // 3. Si la hoja de respuestas NO es 'uncompleted', significa que ha sido COMPLETADA.
                // Un cuestionario completado siempre es 'close'.
               est = 'close';
  }
          }catch(e){
            if (isOverdue) {
                // No empezado y tiempo expirado -> PENDIENTE
                est = 'pending';
            } else if (as.status == 'open') {
                // No empezado y dentro del plazo -> ABIERTO
                est = 'open';
            } else {
                // No empezado y asignación cerrada por el administrador -> CERRADO
                est = 'close';
            }
          }
          this.cuesAsig.push({
            idAsig: as.id,
            inst: as.institution_id,
            cuesAsigId: Number(as.questionary.id),
            cuesNombre: as.questionary.name,
            fechaIni: moment(as.start_date).format("DD/MM/YYYY"),
            fechaFin: moment(as.due_date).format("DD/MM/YYYY"),
            estatus: est,
          });
        }
      }
      this.cuesAsigFiltrados = [...this.cuesAsig];
    }catch(error){
      messages.errorMessageGraph(error);
    }

    if(this.cuesAsig.length === 0){
      messages.infoMessageGraph(this.translate.instant('cues.asignacion.sin-info'));
    }
  }
    public aplicarFiltro(): void {
    // 1. Si el filtro está vacío, mostramos la lista completa
    if (!this.filtroBusqueda || this.filtroBusqueda.trim() === '') {
      this.cuesAsigFiltrados = [...this.cuesAsig];
      return;
    }

    const termino = this.filtroBusqueda.toLowerCase().trim();

    // 2. Filtramos la lista original (cuesAsig)
    this.cuesAsigFiltrados = this.cuesAsig.filter((cuestionario: any) => {
      // Usamos el campo cuesNombre para la búsqueda (debe ser el nombre del cuestionario)
      // Compara el nombre del cuestionario (en minúsculas) con el término de búsqueda
      return cuestionario.cuesNombre.toLowerCase().includes(termino);
    });
  }
  public getFecha(fec){
    return moment(fec,'DD/MM/YYYY').format("MMM.YY");
  }

  public responderCues(cues){
    this.listaCuestionario = false;
    this.cuesSelec = cues;
    messages.infoMessageGraph(this.translate.instant('cues.cuestionarios.sugerencia'));
    this.getHojaRespuestas();
  }

  private async getHojaRespuestas(){
    // se valida en la base de datos si existe una hoja de respuestas para cargar las respuestas guardadas
    try{
      //existe hoja de respuesta previa
      const resp = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getHojaRespuesta,
          context: { headers: this.headers, },
          variables: { allocationId: Number(this.cuesSelec.idAsig) },
          fetchPolicy: 'no-cache',
        }).valueChanges.source
      );
      this.hojaRespuesta = [];
      this.idHojaRes = resp['data'].findAnswerSheet.id;
      for(const r of resp['data'].findAnswerSheet.answers){
        this.hojaRespuesta.push({idPregunta: Number(r.question.id), idRespuesta: Number(r.answerOption.id), comment: r.comment || ''});
      }
      await this.obtDataCuestionario();
    }catch(error){
      //no existe hoja de respuesta previa 
      await this.obtDataCuestionario();
    }
  }
  private async obtDataCuestionario(){
    //aqui va la consulta para obtener toda la informacion relacionada al cuestionario 
    //preguntas respuestas y hoja de respuestas
    try{
      const res = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getCuestionarioPorId,
          context: { headers: this.headers, },
          variables: {
            args: {
              relations: {
                loadRelations: "FULL"
              },
              filter: {
                operator: "AND",
                conditions: [
                  {
                    field: "id",
                    operator: "EQUAL",
                    value: ""+this.cuesSelec.cuesAsigId
                  }
                ]
              },
            },
          }
        }).valueChanges.source 
      );
      this.pregRequeridas = [];
      this.respCuestionario = {
        id: res.data.questionnaires[0].id,
        name: res.data.questionnaires[0].name,
        ponderacion: 0,
        elementos: this.ListelementosCategories(res.data.questionnaires[0].categories, null)
      }
      var peso = 0;
      for(const e of this.respCuestionario['elementos']){
        peso += e.ponderacion*e.peso/100;
      }

      this.semaforos = [];
      var aux = JSON.parse(JSON.stringify(res.data.questionnaires[0].semaphores));
      aux.sort( function(a,b){
        if ( Number(a.value_1) < Number(b.value_1) ) {
          return 1;
        }
        if ( Number(a.value_1) > Number(b.value_1) ) {
          return -1;
        }
        return 0;
      });
      var titN = 1;
      for(const sem of aux){
        var name = this.translate.instant('cues.resultados.titulo-semaforo-'+titN);
        if(name === ('cues.resultados.titulo-semaforo-'+titN)){
          name = '';
        }
        this.semaforos.push({
          name: name,
          min: Number(sem.value_1),
          max: Number(sem.value_2),
          color: sem.color
        });
        titN++;
      } 

      peso = Number(peso.toFixed(1));
      this.respCuestionario['ponderacion'] = peso; 
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  private ListelementosCategories(elements, id){
    var elementos = [];
    var cat;
    if(id === null){
      cat = elements.filter( e => e.parent === id);
    }else{
      cat = elements.filter( e => e.parent !== null && e.parent.id === id);
    }

    cat.sort(function(a,b){
      if ( Number(a.id) > Number(b.id) ) {
        return 1;
      }
      if ( Number(a.id) < Number(b.id) ) {
        return -1;
      }
      return 0;
    });

    if(cat.length === 0){
      return [];
    }

    for(const e of cat){
      const quest = this.structureQuestions(e.questions);
      const eleme = this.ListelementosCategories(elements, e.id);
      var peso = 0;
      if(quest.length !== 0){
        for(const q of quest){
          peso += q.ponderacion*q.peso/100;
        }
      }else if(eleme.length !== 0){
        for(const e of eleme){
          peso += e.ponderacion*e.peso/100;
        }
      }
      // peso = Math.random()*7+3;
      peso = Number(peso.toFixed(1));
      elementos.push({
        id: e.id,
        name: e.name,
        description: e.description,
        parent: e.parent,
        elementos: eleme,
        preguntas: quest,
        ponderacion: peso,
        peso: e.weighting
      });
    }
    return elementos;
  }

  private structureQuestions(questions){
    var newQuestions = [];

    for(const q of questions){
      var res = [];
      for(const r of q.answers_options){
        res.push({
          id: r.id,
          descrip: r.description,
          score: r.score,
          questionId: q.id
        });
      }
      const answer = this.hojaRespuesta.find(c => c.idPregunta === Number(q.id));
      var valor = 0;
      var comentario = '';
      res.sort(function(a,b){
        if ( Number(a.id) > Number(b.id) ) {
          return 1;
        }
        if ( Number(a.id) < Number(b.id) ) {
          return -1;
        }
        return 0;
      });

      try{
        valor = res.find(c => Number(c.id) === Number(answer.idRespuesta)).score*10/10;
        comentario = answer.comment || '';
      }catch(err){
      }

      valor = Number(valor.toFixed(1));

      newQuestions.push({
        id: q.id,
        descripcion: q.description,
        order: q.order,
        requerida: q.required,
        respuestas: res,
        comment: comentario,
        ponderacion: valor,
        peso: q.weighting
      });
      if(q.required){
        this.pregRequeridas.push({
          id: Number(q.id),
        });
      }
    }
    newQuestions.sort(function(a,b){
      if ( Number(a.order) > Number(b.order) ) {
        return 1;
      }
      if ( Number(a.order) < Number(b.order) ) {
        return -1;
      }
      return 0;
    });

    return newQuestions;
  }

  public async guardarRespuestas(){
    try{
      messages.messageSaving(this.translate.instant('acciones.guardandoRes'),this.translate.instant('acciones.espera'))
      const resp = await this.answerSheet.postHojaRespuestas(this.cuesSelec.idAsig, this.hojaRespuesta).toPromise();
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('cues.cuestionarios.guardado'))
      this.listaCuestionario = true;
    }catch(err){
      messages.errorMessageGraph(err);
      return;
    }
    localStorage.setItem('sinGuardar','false');
  }

  private async guardarTerminar(){
    try{
      messages.messageSaving(this.translate.instant('acciones.guardandoRes'),this.translate.instant('acciones.espera'))
      const resp = await this.answerSheet.postHojaRespuestas(this.cuesSelec.idAsig, this.hojaRespuesta).toPromise();
      const finalizar = await this.answerSheet.postFinalize(this.idHojaRes).toPromise();
      Swal.close()
      messages.succesMessageGraph(this.translate.instant('cues.cuestionarios.terminado'))
      this.listaCuestionario = true;
    }catch(err){
      messages.errorMessageGraph(err);
      return;
    }
    localStorage.setItem('sinGuardar','false');
  }

  //metodo para la construccion de la hoja de respuestas 
  public hojaRespuestas(idPregunta, idRespuesta, comment = ''){
    if(this.hojaRespuesta.find((resp) => resp['idPregunta'] == idPregunta)){ //ya existe una respuesta para esa pregunta y se debe actualizar
      var aux = this.hojaRespuesta.find((resp) => resp['idPregunta'] == idPregunta);
      aux.idRespuesta = Number(idRespuesta);
      aux.comment = comment || aux.comment || '';
    }else{ // agregar nueva respuesta
      this.hojaRespuesta.push({idPregunta: Number(idPregunta), idRespuesta: Number(idRespuesta), comment: comment || ''});
    }
    localStorage.setItem('sinGuardar','true')
  }
  
  public async terminar(){
    const result = await messages.confirmationSave(
      this.translate.instant('cues.cuestionarios.alerta-terminar-titulo'),
      this.translate.instant('cues.cuestionarios.alerta-terminar-texto'),
      this.translate
    );
    if(result){
      this.sinContestar = [];
      //se valida que todas la preguntas requeridas hayan sido respondidas
      for(const pr of this.pregRequeridas){
        if(!this.hojaRespuesta.find( p => pr['id'] == p.idPregunta)){ //la pregunta requerda no esta en la hoja de respuesta
          this.sinContestar.push(pr);
        }
      }
      this.bndTerminar = this.sinContestar.length == 0 ? true : false;
      
      if(this.bndTerminar){
        var aux = this.cuesAsig.find((c) => c['idAsig'] === this.cuesSelec.idAsig);
        aux.estatus = 'close'; //se marca la asignacion como terminado por el usuario
        //se envia las respuestas y se marca la asignacion como terminada          
        this.guardarTerminar();          
      }else{
        this.incompleto = true;
        messages.infoMessageGraph(this.translate.instant('cues.cuestionarios.errorTerminar') + this.sinContestar.length + ' preguntas')          
      }
    }
  }
  public async descargarReporte(cues){    
    //aqui se realizara el llamada para generar el reporte recibe como dato el id de la asignacion 
    try{
      messages.messageSaving(this.translate.instant('acciones.descarga'),this.translate.instant('acciones.espera'))
      this.cuesSelec = cues;
      await this.getHojaRespuestas();
      this.isDownloadingPdf = true;
      this.reporteGeneradoExitosamente = false;
      const fechaPiePag = new Date().toLocaleDateString('es-MX', {month: '2-digit',day: '2-digit',year: '2-digit',});
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;

      const colorCalif = this.semaforos.find(s => s.min <= this.respCuestionario['ponderacion'] && this.respCuestionario['ponderacion'] <= s.max).color
      const docPDF = {
        pageSize: 'FOLIO',
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return{
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          }else{
            return{
              text: {
                  text: (currentPage - 1).toString(),
                  alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },margin: [10, -1, 30, 0],
            }
          }
        },
        content: [
          this.imgLogo !== '' && this.imgLogo !== undefined ? {
            image: this.imgLogo,
            width: 220,
            margin: [0, 0, 10, 0],
            absolutePosition: { y: 60 },
            alignment: 'right',
          } : { text: '' },
          {
            text: 'Resultados',
            style: 'header',
            bold: true,
            fontSize: 30,
            color: 'black',
            margin: [60, 250, 0, 0],
          },
          {
            text: this.cuesSelec.cuesNombre,
            style: 'header',
            bold: true,
            fontSize: 30,
            color: 'black',
            margin: [60, 5, 0, 0],
          },
          {
            text: ['Calificación: ',{ text:this.respCuestionario['ponderacion'],color: colorCalif}],
            style: 'header',
            bold: true,
            fontSize: 20,
            color: 'black',
            margin: [60, 25, 0, 0],
          },
          {
            text: this.getFecha(this.cuesSelec.fechaIni),
            style: 'header',
            bold: true,
            fontSize: 18,
            color: 'black',
            margin: [60, 45, 0, 0],
          },
          [
            {text: '', pageBreak: 'after'}
          ],
          this.introduccion(),
          [
            {text: '', pageBreak: 'after'}
          ],
          {
            table: this.formatCuestionario(this.respCuestionario,0),
              layout: {
                hLineColor: function (i) {
                  return 'white';
                },
                vLineColor: function (i, node) {
                  return 'white';
                },
              },
          },
          
        ]
      };

      this.reporteGeneradoExitosamente = true;
   
      this.reportName = 'Reporte '+this.cuesSelec.cuesNombre+'.pdf';
      
      const pdf = pdfMake.createPdf(docPDF);
      await pdf.download(this.reportName);
      const blob = await pdf.getBlob();
      this.pdfFile = blob;
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'))
      setTimeout(() => {
        this.isDownloadingPdf = false;
      }, 2000);
    } catch (error) {
      this.reporteGeneradoExitosamente = false;
      Swal.close();
      Swal.fire({ title: this.translate.instant('cues.reporte.errorReporte'), timer: 20000 });
    }
  }
  private introduccion(){
    var intro = [];
    var comp = [];
    var sem = [];
    for(const c of this.respCuestionario['elementos']){
      comp.push(
        [{
          alignment: 'justify',
          text: c.name,
          style: 'header',
          fontSize: 11,
          color: 'black',
          bold:true,
          border: [false, false, false, true],
          borderColor: ['white','white','white','#44b3e1']
          // margin: [ 30, 10, 0, 0 ]
        }]
      )
    }
    for(const s of this.semaforos){
      sem.push(
        [
          {
            text:'',
            fillColor: s.color
          },
          {
            text: s.name,
            style: 'header',
            fontSize: 11,
            color: 'black',
          },
          {
            text: s.min+' - '+s.max,
            style: 'header',
            fontSize: 11,
            color: 'black',
          }
        ]
      )
    }
    intro = [
      {
        text: this.translate.instant('cues.asignacion.controlInterno')+'\n\n',
        style: 'header',
        fontSize: 16,
        color: 'black',
        bold: true,
        margin: [ 20, 0, 0, 0 ],
      },
      {
        text: this.translate.instant('cues.asignacion.textControlInterno1') + ' '+
          this.translate.instant('cues.asignacion.textControlInterno2')+' '+
          this.translate.instant('cues.asignacion.textControlInterno3'),
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        alignment: 'justify',
        margin: [ 30, 0, 0, 0 ],
      },
      {
        text: '\n\n'+this.translate.instant('cues.asignacion.tituloObjetivo') +'\n',
        style: 'header',
        fontSize: 16,
        color: 'black',
        bold: true,
        margin: [ 20, 10, 0, 0 ],
      },
      {
        ol:[
          this.translate.instant('cues.asignacion.objetivo1'),
          this.translate.instant('cues.asignacion.objetivo2')
        ],
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        alignment: 'justify',
        margin: [ 30, 0, 0, 0 ],
      },
      {
        text: '\n'+this.translate.instant('cues.asignacion.tituloMide')+'\n',
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        margin: [ 30, 10, 0, 0 ],
      },
      {
        ul:[
          this.translate.instant('cues.asignacion.mide1'),
          this.translate.instant('cues.asignacion.mide2'),
          this.translate.instant('cues.asignacion.mide3')
        ],
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        alignment: 'justify',
        margin: [ 30, 0, 0, 0 ],
      },
      {
        text: '\n'+this.translate.instant('cues.asignacion.tituloComp')+'\n',
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        margin: [ 30, 10, 0, 0 ],
      },
      {
        table: {
          headerRows: 1,
          widths: [250],
          body: comp,
        },
        margin: [ 30, 10, 0, 0 ],
        layout: {
          // hLineColor: function (i) {
          //   return '#44b3e1';
          // },
          vLineColor: function (i, node) {
            return 'white';
          },
        },
      },
      {
        text: '\n\n'+this.translate.instant('cues.asignacion.textponderacion1') +
          this.translate.instant('cues.asignacion.textponderacion2')+'\n',
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        margin: [ 30, 10, 0, 0 ],
      },
      {
        table: {
          headerRows: 1,
          widths: [20,100,50],
          body: sem,
        },
        margin: [ 160, 10, 0, 0 ],
        alignment: 'center',
        border: [false, false, false, false],
        layout: {
          hLineColor: function (i) {
            return 'white';
          },
          vLineColor: function (i, node) {
            return 'white';
          },
        },
      },
    ]
    return intro
  }
  private formatCuestionario(array, pos){
    var col;

    let table: any = {
      headerRows: 1,
      widths: [460, 50],
      body: [],
    };

    if(pos===0){
      table.body.push([
        {
          text: '',
          style: 'header',
          bold: true,
        },
        {
          alignment: 'right',
          text: '',
          style: 'header',
          bold: true,
        },
      ]);
    }

    if(pos === 0){
      col = 'black'
    }else{
      col = '#0455B2'
      // col = '#ACBD3D'
    }
    for(const c of array['elementos']){
      var sem = this.semaforos.find(s => s.min <= c.ponderacion && c.ponderacion <= s.max).color;
      table.body.push([
        {
          text: c.name,
          style: 'header',
          fontSize: 15-(2*pos) < 12 ? 12: 15-(2*pos),
          color: col,
          bold: true,
          margin: [ 20*pos, 10, 0, 0 ],
        },
        {
          alignment: 'right',
          text: c.ponderacion,
          style: 'header',
          fontSize: 11,
          bold: true,
          color: sem,
          margin: [ 20*pos, 10, 0, 0 ],
        },
      ]);
      if(c.elementos.length !== 0){//el cuestionario tiene elementos
        const data = this.formatCuestionario(c, pos+1);
        table.body = table.body.concat(data.body);
      }else{// el cuestionario no tiene elementos 
        for(const p of c.preguntas){
          var res;
          var sem2 = this.semaforos.find(s => s.min <= p.ponderacion && p.ponderacion <= s.max).color;
          try{
            res = this.hojaRespuesta.find(r => r.idPregunta == Number(p.id));
            res = p.respuestas.find(r => r.id == res.idRespuesta);
          }catch(e){}
          table.body.push([
            {
              alignment: 'justify',
              text: p.order + '. ' + p.descripcion,
              style: 'header',
              fontSize: 11,
              color: '#1f1f1f',
              margin: [ 20*(pos+1), 10, 0, 0 ]
            },
            {
              alignment: 'right',
              text: p.ponderacion,
              style: 'header',
              fontSize: 11,
              color: sem2,
              margin: [ 0, 10, 0, 0 ]
            },
          ]);
          table.body.push([
            {
              alignment: 'justify',
              text: 'Respuesta: ' + (res ? res.descrip : '-'),
              style: 'header',
              fontSize: 11,
              color: '#808080',
              margin: [ 20*(pos+1.5), 0, 0, 0 ]
            },
            {
              alignment: 'right',
              text: '',
              style: 'header',
              fontSize: 11,
              color: '#808080',
              margin: [ 0, 0, 0, 0 ]
            },      
          ]);
        }
      }
    }
    return table;
  }
private async getLogo(){
  try {
    const response = await firstValueFrom(this.imageService.getLogo(this.dataService.idInstitution));
    for(const doc of response){
      const name = (''+doc['filename']).split('.');
      const nomsep = name[0].split('_');
      for(const nam of nomsep){
        if( nam.toLocaleLowerCase() === 'logo' ){
          const secondResponse = await firstValueFrom(this.imageService.getArchivosA(doc._id));
          // Si secondResponse es ArrayBuffer, conviértelo a base64
          let base64String;
          if (secondResponse instanceof ArrayBuffer) {
            base64String = btoa(
              new Uint8Array(secondResponse).reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
          } else if (typeof secondResponse === 'string' && secondResponse.startsWith('data:image')) {
            // Ya es un dataURL
            this.imgLogo = secondResponse;
            return;
          } else if (typeof secondResponse === 'string') {
            // Es base64 plano
            base64String = secondResponse;
          } else {
            return;
          }
          var base = 'data:image/'+name[name.length-1]+';base64,'+base64String;
          this.imgLogo = base;
          return;
        }
      }
    }      
  } catch (error) {
  }
}


}
